import { render, staticRenderFns } from "./InvoiceSettingsForm.vue?vue&type=template&id=2f90adb9&"
import script from "./InvoiceSettingsForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSettingsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports